export const USER_REGISTER_SUCCESS = "USER_REGISTER_SUCCESS";
export const USER_REGISTER_FAIL = "USER_REGISTER_FAIL";

export const USER_SIGNIN_SUCCESS = "USER_SIGNIN_SUCCESS";
export const USER_SIGNIN_FAIL = "USER_SIGNIN_FAIL";

// export const USER_UPDATE_SUCCESS = "USER_UPDATE_SUCCESS";
// export const USER_UPDATE_ERROR = "USER_UPDATE_ERROR";

export const USER_UPDATE_RESET = "USER_UPDATE_RESER";

export const USER_SIGNOUT = "USER_SIGNOUT";
